import t from "react";
import { c as s, t as a } from "./app-a75c1d35.mjs";
import { I as E, W as N } from "./Icon-3122c134.mjs";
import { B as m } from "./Block-9b78bd10.mjs";
import { L as p } from "./Link-479ac100.mjs";
import "./LinkContext-0c83848a.mjs";
const I = "itemList", g = "itemList__content", x = "itemList__container", C = "itemList__heading", k = "itemList__items", b = "itemList__item", D = "itemList--definition", v = "itemList__item__content", T = "itemList__bullet", h = "itemList--unordered", H = "itemList__bullet--box", P = "itemList__bullet--diamond", O = "itemList__bullet-text", R = "itemList__title", S = "itemList__title--link", A = "itemList__description", M = "itemList__icon", U = "itemList--ordered", e = {
  itemList: I,
  itemListContent: g,
  itemListContainer: x,
  itemListHeading: C,
  itemListItems: k,
  itemListItem: b,
  itemListDefinition: D,
  itemListItemContent: v,
  itemListBullet: T,
  itemListUnordered: h,
  itemListBulletBox: H,
  itemListBulletDiamond: P,
  itemListBulletText: O,
  itemListTitle: R,
  itemListTitleLink: S,
  itemListDescription: A,
  itemListIcon: M,
  itemListOrdered: U
};
function w({
  id: r,
  title: o,
  listType: n,
  items: L,
  className: c
}) {
  const d = () => {
    const i = {
      ordered: e.itemListOrdered,
      unordered: e.itemListUnordered,
      definition: e.itemListDefinition
    };
    return s(e.itemListContainer, i[n]);
  }, u = (i) => n === "ordered" ? /* @__PURE__ */ t.createElement("div", { className: e.itemListBullet }, /* @__PURE__ */ t.createElement("div", { className: e.itemListBulletBox }, /* @__PURE__ */ t.createElement("span", { className: e.itemListBulletText }, i + 1))) : n === "unordered" ? /* @__PURE__ */ t.createElement("div", { className: e.itemListBullet }, /* @__PURE__ */ t.createElement("div", { className: e.itemListBulletDiamond })) : null, l = () => {
    const i = e.itemListTitle;
    return n === "definition" ? s(i, a.textsParagraphSubtitleBold) : s(i, a.textsParagraphSubtitle);
  }, _ = (i) => /* @__PURE__ */ t.createElement(t.Fragment, null, i.linkHref ? /* @__PURE__ */ t.createElement(
    p,
    {
      href: i.linkHref,
      target: i.isExternalLink ? "_blank" : void 0,
      className: s(
        l(),
        e.itemListTitleLink
      )
    },
    i.title,
    /* @__PURE__ */ t.createElement(
      E,
      {
        icon: N.ARROW_RIGHT,
        className: e.itemListIcon
      }
    )
  ) : n === "definition" ? /* @__PURE__ */ t.createElement("h3", { className: l() }, i.title) : /* @__PURE__ */ t.createElement("div", { className: l() }, i.title), i.description && /* @__PURE__ */ t.createElement(
    "p",
    {
      className: s(
        e.itemListDescription,
        a.textsBodyText
      )
    },
    i.description
  )), f = n === "ordered" ? "ol" : "ul";
  return /* @__PURE__ */ t.createElement(
    m,
    {
      id: r,
      as: "section",
      topPadding: m.Padding.SMALL,
      bottomPadding: m.Padding.SMALL,
      className: s(e.itemList, c),
      "data-testid": "item-list"
    },
    /* @__PURE__ */ t.createElement(m.Content, { flex: !0, className: e.itemListContent }, /* @__PURE__ */ t.createElement("div", { className: d() }, o && /* @__PURE__ */ t.createElement(
      "h2",
      {
        className: s(
          e.itemListHeading
        )
      },
      o
    ), /* @__PURE__ */ t.createElement(f, { className: e.itemListItems }, L.map((i, B) => /* @__PURE__ */ t.createElement("li", { key: i.id, className: e.itemListItem }, u(B), /* @__PURE__ */ t.createElement("div", { className: e.itemListItemContent }, _(i)))))))
  );
}
export {
  w as ItemList
};
//# sourceMappingURL=ItemList.js.map
